import * as React from "react"
import { Box, } from "@mui/material"
import Profile from "./profile.jsx"
import { BillingInfo } from "./billing-info.jsx"
import { DeleteProfile } from "./delete-profile.jsx"

export function ProfilePage() {

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        flex: 1,
        gap: 5
      }}
    >
      <Profile />
      <BillingInfo sx={{
        width: "480px",
        maxWidth: "480px"
      }} />
      <DeleteProfile />
    </Box>
  )
}
